import { onErrorCaptured, ref } from 'vue'

export default {
    props: {
        capture: {
            default: false,
            type: Boolean
        }
    },
    emits: ['error'],
    setup(props, { slots, emit, expose }) {
        const error = ref(null)

        onErrorCaptured((e) => {
            error.value = e
            emit('error', error)
            // Optionally capture errors.
            if (props.capture) return false
        })

        const reset = function () {
            error.value = null
            emit('reset')
        }

        expose(onErrorCaptured, reset)

        return () =>
            slots.default({
                error,
                reset
            })
    }
}
